// ==========================================
// src/pages/MinhasCargas.jsx
// MINHAS CARGAS - VERSÃO COM LINK EM TODAS REDES
// ✅ FIX: Link da carga em WhatsApp, Facebook, Telegram, Twitter, LinkedIn, Instagram
// ==========================================

import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/AuthContext';
import { 
  Package, Plus, Loader2, Inbox, BarChart3, Edit3, Trash2, Eye,
  MessageCircle, CheckCircle2, Clock, XCircle, Truck, MapPin,
  ArrowRight, Weight, DollarSign, Calendar, Share2, Copy, Check
} from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Badge } from '@/components/ui/badge';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { motion, AnimatePresence } from 'framer-motion';
import { toast } from 'sonner';
import { supabase } from '@/lib/supabase';

const WHATSAPP_ATENDIMENTO = "5565981181997";
const NOME_EMPRESA = 'BoraFrete';
const URL_SITE = 'https://borafrete.com.br';

// ==========================================
// ÍCONES SVG DAS REDES SOCIAIS
// ==========================================
const WhatsAppIcon = ({ className }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 24 24">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

const FacebookIcon = ({ className }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 24 24">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const TelegramIcon = ({ className }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 24 24">
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
  </svg>
);

const TwitterIcon = ({ className }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 24 24">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

const LinkedInIcon = ({ className }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 24 24">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const InstagramIcon = ({ className }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 24 24">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 100-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
  </svg>
);

const statusConfig = {
  disponivel: { color: 'bg-emerald-100 text-emerald-700 border-emerald-200', label: 'Disponível', icon: CheckCircle2 },
  negociando: { color: 'bg-amber-100 text-amber-700 border-amber-200', label: 'Negociando', icon: Clock },
  aceita: { color: 'bg-blue-100 text-blue-700 border-blue-200', label: 'Aceita', icon: CheckCircle2 },
  em_transito: { color: 'bg-violet-100 text-violet-700 border-violet-200', label: 'Em Trânsito', icon: Truck },
  entregue: { color: 'bg-slate-100 text-slate-700 border-slate-200', label: 'Entregue', icon: CheckCircle2 },
  cancelada: { color: 'bg-red-100 text-red-700 border-red-200', label: 'Cancelada', icon: XCircle }
};

// ==========================================
// ✅ FUNÇÃO AUXILIAR: Gerar texto e link da carga
// ==========================================
const gerarTextoCarga = (carga) => {
  const peso = carga.peso_valor && carga.peso_unidade 
    ? `${carga.peso_valor} ${carga.peso_unidade}`
    : (carga.peso ? `${carga.peso} kg` : 'N/I');
  
  const valor = carga.valor_frete 
    ? `R$ ${Number(carga.valor_frete).toLocaleString('pt-BR', {minimumFractionDigits: 2})}`
    : 'A combinar';

  return `🚛 FRETE DISPONÍVEL!

📦 ${carga.titulo || 'Carga'}

📍 Origem: ${carga.origem_cidade}/${carga.origem_estado}
🏁 Destino: ${carga.destino_cidade}/${carga.destino_estado}

⚖️ Peso: ${peso}
💰 Valor: ${valor}
🚚 Veículo: ${carga.tipo_veiculo || 'N/I'}
📦 Tipo: ${carga.tipo_carga || 'N/I'}

👉 Candidate-se agora!`;
};

// ==========================================
// ✅ FUNÇÃO: Gerar link da carga
// ==========================================
const gerarLinkCarga = (carga) => {
  return `${URL_SITE}/frete/${carga.id}`;
};

// ==========================================
// ✅ CARD HORIZONTAL COM COMPARTILHAMENTO
// ==========================================
const CargaCardHorizontal = ({ carga, onEditar, onExcluir }) => {
  const [showShareMenu, setShowShareMenu] = useState(false);
  const [copiado, setCopiado] = useState(false);
  const status = statusConfig[carga.status] || statusConfig.disponivel;
  const StatusIcon = status.icon;

  const formatarValor = (valor) => {
    const num = Number(valor);
    if (isNaN(num) || num === 0) return 'A combinar';
    return new Intl.NumberFormat('pt-BR', { 
      style: 'currency', 
      currency: 'BRL' 
    }).format(num);
  };

  const formatarPeso = () => {
    if (carga.peso_valor && carga.peso_unidade) {
      return `${carga.peso_valor} ${carga.peso_unidade}`;
    }
    if (carga.peso) return `${carga.peso} kg`;
    return 'N/I';
  };

  // Texto e link da carga
  const textoCarga = gerarTextoCarga(carga);
  const linkCarga = gerarLinkCarga(carga);
  const textoCompleto = `${textoCarga}\n\n🔗 ${linkCarga}`;
  const textoEncoded = encodeURIComponent(textoCompleto);
  const linkEncoded = encodeURIComponent(linkCarga);

  // ==========================================
  // AÇÕES DE COMPARTILHAMENTO
  // ==========================================
  
  const copiarTexto = () => {
    navigator.clipboard.writeText(textoCompleto).then(() => {
      setCopiado(true);
      toast.success('Texto e link copiados!');
      setTimeout(() => setCopiado(false), 3000);
    });
  };

  const compartilharWhatsApp = () => {
    window.open(`https://wa.me/?text=${textoEncoded}`, '_blank');
    setShowShareMenu(false);
  };

  const compartilharFacebook = () => {
    // Facebook Share Dialog com link e quote
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${linkEncoded}&quote=${encodeURIComponent(textoCarga)}`, '_blank');
    setShowShareMenu(false);
  };

  const compartilharTelegram = () => {
    window.open(`https://t.me/share/url?url=${linkEncoded}&text=${encodeURIComponent(textoCarga)}`, '_blank');
    setShowShareMenu(false);
  };

  const compartilharTwitter = () => {
    const textoTwitter = `${textoCarga.substring(0, 200)}... 🔗 ${linkCarga}`;
    window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(textoTwitter)}`, '_blank');
    setShowShareMenu(false);
  };

  const compartilharLinkedIn = () => {
    // LinkedIn sharing com URL e texto
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${linkEncoded}`, '_blank');
    setShowShareMenu(false);
  };

  const compartilharInstagram = () => {
    navigator.clipboard.writeText(textoCompleto).then(() => {
      toast.success('Texto e link copiados! Cole no Instagram.');
      setShowShareMenu(false);
    });
  };

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-4 hover:shadow-md transition-all duration-200 group relative">
      <div className="flex items-start gap-4">
        {/* Ícone/Status */}
        <div className={`w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 ${status.color.split(' ')[0]}`}>
          <StatusIcon className="w-6 h-6" />
        </div>

        {/* Conteúdo */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <h3 className="font-bold text-slate-900 truncate text-base">{carga.titulo || 'Carga sem título'}</h3>
            <Badge className={`text-xs ${status.color}`}>
              {status.label}
            </Badge>
          </div>

          {/* Rota */}
          <div className="flex items-center gap-2 text-sm text-slate-600 mb-2">
            <MapPin className="w-4 h-4 text-slate-400" />
            <span className="truncate">
              {carga.origem_cidade}/{carga.origem_estado} 
              <ArrowRight className="w-3 h-3 inline mx-1 text-slate-400" />
              {carga.destino_cidade}/{carga.destino_estado}
            </span>
          </div>

          {/* Info em linha */}
          <div className="flex flex-wrap items-center gap-3 text-xs text-slate-500">
            <span className="flex items-center gap-1">
              <Weight className="w-3 h-3" />
              {formatarPeso()}
            </span>
            <span className="flex items-center gap-1">
              <Truck className="w-3 h-3" />
              {carga.tipo_veiculo || 'N/I'}
            </span>
            <span className="flex items-center gap-1">
              <Calendar className="w-3 h-3" />
              {carga.data_coleta ? new Date(carga.data_coleta).toLocaleDateString('pt-BR') : 'N/I'}
            </span>
            <span className="font-semibold text-slate-700">
              {formatarValor(carga.valor_frete)}
            </span>
          </div>
        </div>

        {/* AÇÕES */}
        <div className="flex flex-col gap-2 flex-shrink-0 relative">
          {/* Compartilhar */}
          <div className="relative">
            <Button 
              variant="outline" 
              size="sm" 
              onClick={() => setShowShareMenu(!showShareMenu)}
              className={`h-8 px-3 border-orange-200 text-orange-600 hover:bg-orange-50 ${showShareMenu ? 'bg-orange-100' : ''}`}
            >
              <Share2 className="w-3 h-3 mr-1" />
              Compartilhar
            </Button>

            {/* Menu de redes sociais */}
            <AnimatePresence>
              {showShareMenu && (
                <motion.div
                  initial={{ opacity: 0, y: -10, scale: 0.95 }}
                  animate={{ opacity: 1, y: 0, scale: 1 }}
                  exit={{ opacity: 0, y: -10, scale: 0.95 }}
                  className="absolute right-0 top-full mt-2 bg-white rounded-xl shadow-xl border border-slate-200 p-3 z-50 min-w-[220px]"
                >
                  <p className="text-xs font-semibold text-slate-500 mb-2 uppercase tracking-wide">Compartilhar em</p>
                  
                  <div className="grid grid-cols-3 gap-2">
                    {/* WhatsApp */}
                    <button
                      onClick={compartilharWhatsApp}
                      className="flex flex-col items-center gap-1 p-2 rounded-lg hover:bg-green-50 transition-all hover:scale-110"
                      title="WhatsApp"
                    >
                      <WhatsAppIcon className="w-6 h-6 text-green-500" />
                      <span className="text-[10px] text-slate-600">WhatsApp</span>
                    </button>

                    {/* Facebook */}
                    <button
                      onClick={compartilharFacebook}
                      className="flex flex-col items-center gap-1 p-2 rounded-lg hover:bg-blue-50 transition-all hover:scale-110"
                      title="Facebook"
                    >
                      <FacebookIcon className="w-6 h-6 text-blue-600" />
                      <span className="text-[10px] text-slate-600">Facebook</span>
                    </button>

                    {/* Telegram */}
                    <button
                      onClick={compartilharTelegram}
                      className="flex flex-col items-center gap-1 p-2 rounded-lg hover:bg-sky-50 transition-all hover:scale-110"
                      title="Telegram"
                    >
                      <TelegramIcon className="w-6 h-6 text-sky-500" />
                      <span className="text-[10px] text-slate-600">Telegram</span>
                    </button>

                    {/* Twitter/X */}
                    <button
                      onClick={compartilharTwitter}
                      className="flex flex-col items-center gap-1 p-2 rounded-lg hover:bg-slate-100 transition-all hover:scale-110"
                      title="Twitter/X"
                    >
                      <TwitterIcon className="w-5 h-5 text-slate-800" />
                      <span className="text-[10px] text-slate-600">Twitter</span>
                    </button>

                    {/* LinkedIn */}
                    <button
                      onClick={compartilharLinkedIn}
                      className="flex flex-col items-center gap-1 p-2 rounded-lg hover:bg-blue-50 transition-all hover:scale-110"
                      title="LinkedIn"
                    >
                      <LinkedInIcon className="w-5 h-5 text-blue-700" />
                      <span className="text-[10px] text-slate-600">LinkedIn</span>
                    </button>

                    {/* Instagram */}
                    <button
                      onClick={compartilharInstagram}
                      className="flex flex-col items-center gap-1 p-2 rounded-lg hover:bg-pink-50 transition-all hover:scale-110"
                      title="Instagram"
                    >
                      <InstagramIcon className="w-6 h-6 text-pink-500" />
                      <span className="text-[10px] text-slate-600">Instagram</span>
                    </button>
                  </div>

                  {/* Copiar Texto + Link */}
                  <button
                    onClick={copiarTexto}
                    className={`w-full mt-2 flex items-center justify-center gap-2 py-2 rounded-lg text-sm font-medium transition-all ${
                      copiado 
                        ? 'bg-green-100 text-green-700 border border-green-300' 
                        : 'bg-slate-100 hover:bg-slate-200 text-slate-700'
                    }`}
                  >
                    {copiado ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
                    {copiado ? 'Copiado!' : 'Copiar Texto + Link'}
                  </button>
                </motion.div>
              )}
            </AnimatePresence>
          </div>

          {/* Editar */}
          <Button 
            variant="outline" 
            size="sm" 
            onClick={() => onEditar(carga)}
            className="h-8 px-3 border-blue-200 text-blue-600 hover:bg-blue-50"
          >
            <Edit3 className="w-3 h-3 mr-1" />
            Editar
          </Button>

          {/* Excluir */}
          <Button 
            variant="outline" 
            size="sm" 
            onClick={() => onExcluir(carga)}
            className="h-8 px-3 border-red-200 text-red-600 hover:bg-red-50"
          >
            <Trash2 className="w-3 h-3 mr-1" />
            Excluir
          </Button>
        </div>
      </div>
    </div>
  );
};

export default function MinhasCargas() {
  const navigate = useNavigate();
  const { user, loading: authLoading, isAuthenticated } = useAuth();
  const [cargas, setCargas] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('disponiveis');
  const [cargaSelecionada, setCargaSelecionada] = useState(null);
  const [modalExcluirOpen, setModalExcluirOpen] = useState(false);

  useEffect(() => {
    if (!authLoading && !isAuthenticated) {
      navigate('/login?from=' + encodeURIComponent(window.location.href));
    }
  }, [authLoading, isAuthenticated, navigate]);

  // ✅ SUPABASE: Buscar cargas da empresa logada
  const fetchCargas = useCallback(async () => {
    if (!user?.email && !user?.id) return;
    
    try {
      setIsLoading(true);
      
      console.log('🔍 Buscando cargas para empresa:', {
        userId: user.id,
        userEmail: user.email
      });

      const { data, error } = await supabase
        .from('cargas')
        .select('*')
        .or(`empresa_id.eq.${user.id},created_by.eq.${user.email}`)
        .order('created_at', { ascending: false });

      if (error) throw error;

      console.log('✅ Cargas encontradas:', data?.length || 0);
      setCargas(data || []);
    } catch (error) { 
      console.error('❌ Erro ao buscar cargas:', error);
      toast.error('Erro ao carregar suas cargas');
      setCargas([]);
    } finally { 
      setIsLoading(false); 
    }
  }, [user]);

  useEffect(() => {
    if (isAuthenticated && user) fetchCargas();
  }, [user, isAuthenticated, fetchCargas]);

  // ✅ SUPABASE: Subscribe para atualizações em tempo real
  useEffect(() => {
    if (!user?.id) return;

    const subscription = supabase
      .channel('minhas_cargas')
      .on('postgres_changes', 
        { 
          event: '*', 
          schema: 'public', 
          table: 'cargas',
          filter: `empresa_id=eq.${user.id}`
        }, 
        (payload) => {
          console.log('🔄 Mudança detectada em minhas cargas:', payload);
          fetchCargas();
        }
      )
      .subscribe();

    return () => {
      subscription.unsubscribe();
    };
  }, [user, fetchCargas]);

  const cargasDisponiveis = cargas.filter(c => c.status === 'disponivel' || c.status === 'negociando');
  const cargasAtivas = cargas.filter(c => c.status === 'aceita' || c.status === 'em_transito');
  const cargasFinalizadas = cargas.filter(c => c.status === 'entregue' || c.status === 'cancelada');

  const handleEditar = (carga) => {
    console.log('Editando carga:', carga.id);
    navigate(`/editar-carga/${carga.id}`, { state: { carga } });
  };
  
  const handleExcluir = (carga) => { 
    setCargaSelecionada(carga); 
    setModalExcluirOpen(true); 
  };

  // ✅ RPC: Excluir carga (bypass RLS)
  const confirmarExclusao = async () => {
    if (!cargaSelecionada) return;
    
    try {
      console.log('🗑️ Excluindo carga via RPC:', cargaSelecionada.id);
      
      const { data: rpcResult, error: rpcError } = await supabase.rpc('excluir_carga', {
        p_carga_id: cargaSelecionada.id
      });

      if (rpcError) {
        console.error('❌ RPC erro:', rpcError);
        throw rpcError;
      }

      console.log('✅ RPC resultado:', rpcResult);

      if (rpcResult && rpcResult.success === true) {
        setCargas(cargas.filter(c => c.id !== cargaSelecionada.id));
        setModalExcluirOpen(false);
        toast.success('Carga excluída com sucesso!');
        return;
      }

      if (rpcResult && rpcResult.success === false) {
        console.error('❌ RPC retornou erro:', rpcResult.error);
        throw new Error(rpcResult.error || 'Erro ao excluir carga');
      }

      throw new Error('Resposta inesperada do servidor');

    } catch (error) {
      console.error('❌ Erro ao excluir:', error);
      toast.error('Erro ao excluir carga: ' + (error.message || 'Tente novamente'));
    }
  };

  const handleWhatsAppGeral = () => {
    const mensagem = encodeURIComponent(
      `👋 *Empresa: ${user?.nome || user?.razaoSocial || 'BoraFrete'}*\n\n` +
      `📦 *Resumo:*\n• Total: ${cargas.length} cargas\n\nPreciso de atendimento.`
    );
    window.open(`https://wa.me/${WHATSAPP_ATENDIMENTO}?text=${mensagem}`, '_blank');
  };

  if (authLoading || isLoading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <motion.div animate={{ rotate: 360 }} transition={{ duration: 1, repeat: Infinity }} className="w-12 h-12 rounded-full border-4 border-blue-200 border-t-blue-600" />
      </div>
    );
  }

  if (!isAuthenticated) return null;

  const renderizarAba = (cargasFiltradas, mensagemVazio) => {
    if (cargasFiltradas.length === 0) {
      return (
        <div className="text-center py-16 bg-white rounded-2xl border border-slate-200">
          <Inbox className="w-16 h-16 text-slate-300 mx-auto mb-4" />
          <p className="text-slate-600">{mensagemVazio}</p>
          <p className="text-sm text-slate-400 mt-2">
            Total de cargas no sistema: {cargas.length}
          </p>
        </div>
      );
    }

    return (
      <div className="space-y-3">
        {cargasFiltradas.map((carga, index) => (
          <CargaCardHorizontal 
            key={carga.id || index}
            carga={carga}
            onEditar={handleEditar}
            onExcluir={handleExcluir}
          />
        ))}
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-slate-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div className="mb-8">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-indigo-500 to-violet-600 flex items-center justify-center shadow-lg">
                <BarChart3 className="w-6 h-6 text-white" />
              </div>
              <div>
                <h1 className="text-3xl font-bold text-slate-900">Minhas Cargas</h1>
                <p className="text-slate-600">Gerencie suas cargas publicadas</p>
              </div>
            </div>
            
            <div className="flex items-center gap-3">
              <Button onClick={handleWhatsAppGeral} className="bg-emerald-500 hover:bg-emerald-600 text-white gap-2">
                <MessageCircle className="w-4 h-4" />Atendimento
              </Button>
              <Link to="/nova-carga">
                <Button className="bg-gradient-to-r from-indigo-500 to-violet-600 hover:from-indigo-600 hover:to-violet-700 shadow-lg">
                  <Plus className="w-4 h-4 mr-2" />Nova Carga
                </Button>
              </Link>
            </div>
          </div>
        </motion.div>

        <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
          <TabsList className="bg-white border border-slate-200 p-1 rounded-xl w-full">
            <TabsTrigger value="disponiveis" className="data-[state=active]:bg-slate-900 data-[state=active]:text-white rounded-lg px-6 py-2 flex-1">
              Disponíveis <Badge className="ml-2 bg-slate-100">{cargasDisponiveis.length}</Badge>
            </TabsTrigger>
            <TabsTrigger value="ativas" className="data-[state=active]:bg-slate-900 data-[state=active]:text-white rounded-lg px-6 py-2 flex-1">
              Ativas <Badge className="ml-2 bg-slate-100">{cargasAtivas.length}</Badge>
            </TabsTrigger>
            <TabsTrigger value="finalizadas" className="data-[state=active]:bg-slate-900 data-[state=active]:text-white rounded-lg px-6 py-2 flex-1">
              Finalizadas <Badge className="ml-2 bg-slate-100">{cargasFinalizadas.length}</Badge>
            </TabsTrigger>
          </TabsList>

          <TabsContent value="disponiveis" className="mt-0">
            {renderizarAba(cargasDisponiveis, 'Nenhuma carga disponível')}
          </TabsContent>
          
          <TabsContent value="ativas" className="mt-0">
            {renderizarAba(cargasAtivas, 'Nenhuma carga ativa no momento')}
          </TabsContent>
          
          <TabsContent value="finalizadas" className="mt-0">
            {renderizarAba(cargasFinalizadas, 'Nenhuma carga finalizada')}
          </TabsContent>
        </Tabs>
      </div>

      <Dialog open={modalExcluirOpen} onOpenChange={setModalExcluirOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Confirmar Exclusão</DialogTitle>
            <DialogDescription>
              Tem certeza que deseja excluir a carga "{cargaSelecionada?.titulo}"? Esta ação não pode ser desfeita.
            </DialogDescription>
          </DialogHeader>
          <DialogFooter className="flex gap-2">
            <Button variant="outline" onClick={() => setModalExcluirOpen(false)}>Cancelar</Button>
            <Button variant="destructive" onClick={confirmarExclusao}>Excluir</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}